import { useState } from 'react';
import Router from './service/routes/routes';
import './index.css'
import './App.css'
import DataContext from './DataContext';
import navItems from './placesInfo';



function App() {
  const [selected, setSelected] = useState(navItems[0]);

  return (
    <div className="App">
      <DataContext.Provider value={{ selected, setSelected }} >
        <Router />
      </DataContext.Provider>
    </div>
  );
}
export default App;
